import React from 'react'
import { Route, Switch, useRouteMatch } from 'react-router'

import ErrorPage from '../../pages/ErrorPage'

const ErrorRoute = () => {
  const { path } = useRouteMatch()

  return (
    <Switch>
      <Route path={path} component={ErrorPage} />
    </Switch>
  )
}

export default ErrorRoute
